import { useEffect, useRef } from "react";
import { prefersReducedMotion } from "@/lib/motion";

type HeroVideoProps = {
  src: string;
  poster: string;
  className?: string;
};

/**
 * Single looping hero clip. The poster is the LCP paint; after hydration the
 * muted video starts playing unless the visitor prefers reduced motion or has
 * Save-Data on, in which case the poster simply stays put.
 */
export function HeroVideo({ src, poster, className }: HeroVideoProps) {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    if (prefersReducedMotion()) return;
    const conn = (navigator as unknown as { connection?: { saveData?: boolean } })
      .connection;
    if (conn?.saveData) return;
    v.src = src;
    v.load();
    v.play().catch(() => {});
  }, [src]);

  return (
    <video
      ref={ref}
      className={className}
      poster={poster}
      muted
      loop
      playsInline
      preload="metadata"
      aria-hidden="true"
    />
  );
}
